import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	LinearProgress,
} from "@mui/material";
import { useFinishedTaskDataStore } from "../../../store/useDataStore";
import useIntersectionObserver from "../../../hooks/useIntersectionObserver";
import React, { useEffect } from "react";

const headers = [
	"Operator Name",
	"Task Duration",
	"Property ID",
	"Property Address",
	"City",
	"Organization",
	"Type",
	"Last Updated",
];

const PropertyCompletedTable = ({ loading, fetchData, setLoading }: any) => {
	const { data: propertyTasks, isLastPage, pageNo, option } = useFinishedTaskDataStore();

	const loadData = async () => {
		setLoading(true);
		await fetchData(option, pageNo + 1);
		setLoading(false);
	};

	const lastQuestionRef: any = useIntersectionObserver<any>(loadData, [!isLastPage, !loading]);

	useEffect(() => {
		// if (isLastPage || pageNo > 1) return;

		fetchData(option, 1);
	}, []);

	function calculateDuration(timestamp1: string, timestamp2: string): string {
		const date1 = new Date(timestamp1).getTime();
		const date2 = new Date(timestamp2).getTime();

		const duration = Math.abs(date1 - date2); // Ensure positive duration

		if (isNaN(duration)) {
			throw new Error("Invalid timestamps");
		}

		const hours = Math.floor(duration / (1000 * 60 * 60));
		const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((duration % (1000 * 60)) / 1000);

		const parts = [];
		if (hours > 0) parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
		if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);
		if (seconds > 0 || parts.length === 0)
			parts.push(`${seconds} second${seconds > 1 ? "s" : ""}`);

		return parts.join(", ");
	}

	const capitalizeFirstWord = (str: string) => str?.[0]?.toUpperCase() + str?.slice(1) || "";

	const getCompletionTime = (row: any) => {
		if (row?.taskSourceType === "mail") {
			return calculateDuration(
				row?.mailDetails?.verificationTime?.endTime,
				row?.mailDetails?.verificationTime?.startTime
			);
		} else if (row?.taskSourceType === "email") {
			return calculateDuration(
				row?.emailDetails?.verificationTime?.endTime,
				row?.emailDetails?.verificationTime?.startTime
			);
		}
	};

	return (
		<>
			{loading ? <LinearProgress style={{ height: "2px" }} /> : null}
			<TableContainer
				component={Paper}
				sx={{
					boxShadow: "none",
					border: 0,
					height: "calc(100vh - 230px)",
					overflow: "scroll",
				}}
			>
				<Table stickyHeader>
					<TableHead>
						<TableRow>
							{headers.map((header) => (
								<TableCell id="table-header-row" align="left" key={header}>
									{header}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{propertyTasks.map((row: any, index: number) => (
							<TableRow
								ref={propertyTasks.length - 1 === index ? lastQuestionRef : null}
								key={row.name}
								id="table-body-tableRow"
							>
								<TableCell align="left">{row.user}</TableCell>
								<TableCell align="left">{getCompletionTime(row)}</TableCell>
								<TableCell align="left">{row.objectId || "N/A"}</TableCell>
								<TableCell align="left">{row.fullAddress || "N/A"}</TableCell>
								<TableCell align="left">{row?.info?.city || "N/A"}</TableCell>
								<TableCell align="left">{row.organizationName}</TableCell>
								<TableCell align="left">
									{capitalizeFirstWord(row?.taskSourceType) || "N/A"}
								</TableCell>
								<TableCell align="left">
									{new Date(row?.updatedAt).toLocaleString()}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default PropertyCompletedTable;
